import { createGlobalStyle } from "styled-components";
const GlobalFontStyle = createGlobalStyle`
  body {
    font-family: ${window.ENV.FONT_FAMILY || 'UP-Book, sans-serif'};
  }
`;

export default GlobalFontStyle;